<template>
  <div class="mFooter-container">
    <div class="mLogo-container">
      <img :src="logoIcon" alt="logo" width="1538" height="941"/>
    </div>
    <div class="mPrivacy-container">
      <div class="mPrivacy-links">
        <h2 class="privacy clickable" @click="$router.push('/tycos')">
          Términos y Condiciones
        </h2>
        <span class="privacy bar">|</span>
        <h2 class="privacy clickable" @click="$router.push('/politics')">
          Aviso de Privacidad
        </h2>
        <span class="privacy bar">|</span>
        <h2 class="privacy clickable" @click="$router.push('/cookies')">
          Política de Cookies
        </h2>
        <span class="privacy bar" v-if="showInfoOption & getAgeGateToken">|</span>
        <h2 v-if="showInfoOption & getAgeGateToken" class="privacy clickable" @click="showModalInfo = true">
          Información de Productos
        </h2>
        <span class="privacy bar">|</span>
        <h2 class="privacy">
          Evita el Exceso
        </h2>
        <!--<span class="privacy bar nomobile">|</span>
        <h4 class="privacy nomobile">213300201A0563</h4>
        <span class="privacy bar nomobile">|</span>
        <h4 class="privacy clickable nomobile">Evita el Exceso</h4>-->
      </div>
      <!--<div class="privacy-second">      <h4 class="privacy nodesktop">213300201A0563</h4>
      <span class="privacy bar nodesktop">|</span>
      <h4 class="privacy nodesktop">Evita el Exceso</h4></div>-->
     
    </div>
    <div class="mSocialmedia-container">
      <a
        id="twitter"
        class="social-icon"
        target="_blank"
        rel="noopener"
        href="https://twitter.com/strongbowmx?lang=es" @click="socialClick('Twitter','Interaction')"
        ><img :src="twIcon" alt="Twitter" width="177" height="173"
      /></a>
      <a
        id="instagram"
        class="social-icon"
        target="_blank"
        rel="noopener"
        href="https://www.instagram.com/strongbow/" @click="socialClick('Instagram','Interaction')"
        ><img :src="inIcon" alt="Instagram" width="177" height="173"
      /></a>
      <a
        id="facebook"
        class="social-icon"
        target="_blank"
        rel="noopener"
        href="https://www.facebook.com/StrongbowMX/" @click="socialClick('Facebook','Interaction')"
        ><img :src="fbIcon" alt="Facebook" width="177" height="173"
      /></a>
      <a
        id="youtube"
        class="social-icon"
        target="_blank"
        rel="noopener"
        href="javascript:void(0)" @click="socialClick('Youtube','Interaction')"
        ><img :src="ytIcon" alt="Youtube" width="177" height="173"
      /></a>
    </div>
    <Modal
      v-if="showModal"
      v-bind:wichModal="wichModal"
      @close="showModal = false"
    />
     <ModalInfo v-if="showModalInfo" @close="showModalInfo = false"></ModalInfo>
  </div>
</template>

<script>
import Modal from "@/components/Modal";
import ModalInfo from "@/components/ModalInfoProduct";
import logoIcon from "@/assets/Logo_Strongbow.png";
import fbIcon from "@/assets/facebook.png";
import twIcon from "@/assets/twitter.png";
import ytIcon from "@/assets/youtube.png";
import inIcon from "@/assets/instagram.png";
import tagFunctions from '@/utils/tagFunctions.js';
import { mapActions, mapGetters  } from "vuex";

const utm1 = {
  utm_content: "QR_AvisoAlcohol",
  utm_medium: "PopUp",
  utm_source: "Lata-Strongbow",
};

export default {
  name: "FooterHome",
  data() {
    return {
      showModal: false,
      wichModal: "terms",
      showModalInfo: false,
      showInfoOption: false,
      logoIcon,
      fbIcon,
      twIcon,
      ytIcon,
      inIcon,
    };
  },
  mounted() {
    const { utm_source, utm_medium, utm_content } = this.$route.query;
    if (
      utm1["utm_source"] === utm_source &&
      utm1["utm_content"] === utm_content &&
      utm1["utm_medium"] === utm_medium
    ) {
      setTimeout(() => {
        this.showInfoOption = true;
      }, 3000);
    }
  },
  methods: {
    popUpModal(modalType) {
      this.showModal = true;
      this.wichModal = modalType;
    },
    ...mapActions({
      setAgeGateTokenAction: "setAgeGateToken",
    }),
    socialClick(socialNetwork, action){
      tagFunctions.evSocialNetworkPush(socialNetwork, action)
    }
  },
  components: {
    Modal,
    ModalInfo
  },
  computed: {
    ...mapGetters(["getAgeGateToken", "isLoaded"]),
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/FooterHome.scss";
</style>
